__turbopack_context__.v({
  "active": "SearchTabs-module__mPbcwa__active",
  "blok-big-title": "SearchTabs-module__mPbcwa__blok-big-title",
  "blok-subtitle": "SearchTabs-module__mPbcwa__blok-subtitle",
  "blok-title": "SearchTabs-module__mPbcwa__blok-title",
  "root": "SearchTabs-module__mPbcwa__root",
  "tag": "SearchTabs-module__mPbcwa__tag",
});
